import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import { DropdownBaseQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-base-query.dto';
import { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';
import { ContractFindInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-find.dto';
import { ContractService } from '@zaoblako/web/core/services/finance/contract.service';
import { BaseSingleSelectComponent } from '@zaoblako/web/shared/components/base-single-select/base-single-select.component';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'crm-contract-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, SpinnerComponent],
  templateUrl: './contract-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractSingleSelectComponent extends BaseSingleSelectComponent<ContractFindInterface> {
  public availableModule = 'FINANCE';

  @Input() public companyIds: number[] = [];
  @Input() public contragentIds: number[] = [];

  public constructor(private readonly contractService: ContractService) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const companyChanged = Boolean(changes.companyIds) && !changes.companyIds.firstChange;
    const contragentChanged = Boolean(changes.contragentIds) && !changes.contragentIds.firstChange;
    if (companyChanged || contragentChanged) {
      this.firstLoad();
      return;
    }
    super.ngOnChanges(changes);
  }

  public findById(id: number): Observable<ContractFindInterface> {
    return this.contractService.findById(id);
  }

  public findWithPagination(
    queryParams: Partial<DropdownBaseQueryInterface>
  ): Observable<PaginationFindInterface<ContractFindInterface>> {
    return this.contractService.findWithPagination({
      ...queryParams,
      companyIds: this.companyIds,
      contragentIds: this.contragentIds
    });
  }
}
